import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BasicDetailsForm } from '@models/DPI/BasicDetails.model';
import { CoverageForm } from '@models/DPI/Coverage.model';
import { SQSPocketResponse } from '@models/SQSPocketRequest.model'
import { IOccupation } from '../model';

export interface Step1State {
  basicDetails: BasicDetailsForm | null;
  coverage: CoverageForm | null;
  sqsQuotation: SQSPocketResponse | null;
  occupationCode: string | null;
  occupation: IOccupation | null;
  appliedPromoCode: string | null;
  quoteRawResponse: object | null;
  quoteRawRequest: object | null;
  isCompleted: boolean;
  generalQuestions: string | null;
  transactionId: string,
}

const initialState: Step1State = {
  basicDetails: null,
  coverage: new CoverageForm(null),
  sqsQuotation: null,
  appliedPromoCode: null,
  quoteRawResponse: null,
  quoteRawRequest: null,
  occupationCode: null,
  occupation: null,
  isCompleted: false,
  generalQuestions: null,
  transactionId:'',
}

const step1Slice = createSlice({
  name: 'DPI-Step1',
  initialState,
  reducers: {
    updateBasicDetails: (state, action: PayloadAction<BasicDetailsForm>) => {
      state.basicDetails = action.payload
    },
    updateCoverage: (state, action: PayloadAction<CoverageForm>) => {
      state.coverage = action.payload
    },
    updateSQSQuotation: (state, action: PayloadAction<SQSPocketResponse>) => {
      state.sqsQuotation = action.payload
    },
    updateQuoteResponse: (state, action: PayloadAction<object>) => {
      state.quoteRawResponse = action.payload
    },
    updateOccupationCode: (state, action: PayloadAction<string>) => {
      state.occupationCode = action.payload
    },
    updateOccupation: (state, action: PayloadAction<IOccupation>) => {
      state.occupation = action.payload
    },
    updateQuoteRequest: (state, action: PayloadAction<object>) => {
      state.quoteRawRequest = action.payload
    },
    updateGeneralQuestions: (state, action: PayloadAction<string>) => {
      state.generalQuestions = action.payload
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateTransactionId: (state,action: PayloadAction<string>)=>{
      state.transactionId = action.payload
    }
  },
  extraReducers: {}
})

export const { 
  updateBasicDetails,
  updateCoverage,
  updateSQSQuotation,
  updateQuoteResponse,
  updateOccupation,
  updateOccupationCode,
  updateQuoteRequest,
  updateGeneralQuestions,
  completeStep,
  updateTransactionId
} = step1Slice.actions;

export default step1Slice.reducer;